var map = {
	"./10ans.png": 322,
	"./11ans.png": 323,
	"./12ans.png": 324,
	"./3ans.png": 325,
	"./4ans.png": 326,
	"./5ans.png": 327,
	"./6ans.png": 328,
	"./7ans.png": 329,
	"./8ans.png": 330,
	"./9ans.png": 331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 321;